import { useState } from "react"
import { Button } from "@/components/ui/Button"
import { Input } from "@/components/ui/Input"
import { MailIcon } from "lucide-react"
import { useTranslation } from "react-i18next"

export function WaitlistSection() {
    const { t } = useTranslation('landing')
    const [email, setEmail] = useState("")
    const [submitted, setSubmitted] = useState(false)

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault()
        if (email) {
            console.log("Waitlist signup:", email)
            localStorage.setItem("de-zign-waitlist-email", email)
            setSubmitted(true)
            setEmail("")
        }
    }

    return (
        <section className="py-20 relative overflow-hidden bg-gradient-to-br from-pink-600/20 via-purple-600/20 to-emerald-600/20 dark:from-emerald-700/20 dark:via-purple-700/20 dark:to-pink-700/20">
            {/* Orbs for depth */}
            <div className="absolute top-0 right-0 w-96 h-96 bg-emerald-500/50 dark:bg-emerald-500/10 rounded-full blur-3xl animate-float" />
            <div className="absolute bottom-0 left-0 w-80 h-80 bg-purple-500/50 dark:bg-purple-500/30 rounded-full blur-3xl animate-float" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-pink-500/50 dark:bg-pink-500/10 rounded-full blur-3xl animate-pulse-slow" />

            <div className="container mx-auto px-4 relative bg-gray-300/50 drak:bg-gray-900/10 p-8 bg-blur rounded-lg ">
                <div className="max-w-xl mx-auto text-center">
                    <MailIcon className="w-12 h-12 mx-auto mb-6 text-white/90" />
                    <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
                        {t('waitlist.title')}
                    </h2>
                    <p className="text-white/90 mb-8 max-w-md mx-auto">
                        {t('waitlist.subtitle')}
                    </p>

                    {submitted ? (
                        <div className="bg-white/10 backdrop-blur-md rounded-xl p-8 animate-fade-in-up border border-white/20">
                            <p className="text-xl font-medium text-white">{t('waitlist.success.message')}</p>
                            <p className="text-white/80 mt-2">
                                {t('waitlist.success.submessage')}
                            </p>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
                            <Input
                                type="email"
                                placeholder={t('waitlist.placeholder')}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="bg-white/10 border-white/20 text-white placeholder:text-white/60 focus:bg-white/20 focus:border-white/40 transition-all duration-300 backdrop-blur-sm"
                            />
                            <Button
                                type="submit"
                                variant="secondary"
                                size="lg"
                                className="bg-white text-purple-700 hover:bg-white/90 hover:scale-105 transition-all duration-300 shadow-lg font-semibold"
                            >
                                {t('waitlist.submit')}
                            </Button>
                        </form>
                    )}
                </div>
            </div>
        </section>
    )
}
